export default __webpack_public_path__ + "static/media/icon_mp3.100b218f.svg";